module.exports = __webpack_public_path__ + "img/p_suggest.45685001.png";